export const supplierCatgories = [
    { label: "Manufacturer", value: "Manufacturer" },
    { label: "Ingredient Supplier", value: "Ingredient Supplier" },
    { label: "Packaging Supplier", value: "Packaging Supplier" },
    { label: "Raw Material Supplier", value: "Raw Material Supplier" },
    { label: "Freight Supplier", value: "Freight Supplier" },
];
